
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isBrowserSafari } from '../../core/helpers/device';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor(@Inject(DOCUMENT) private document: Document) {
    const cookies = this.document.cookie.split(';');

    let cookiehubCookies = 0;

    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].includes('cookiehub')) {
        cookiehubCookies += 1;
      }
    }

    if (cookiehubCookies > 1) {
      this.document.cookie =
        'cookiehub' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.clone.pinpointworks.com';
      this.document.cookie =
        'cookiehub' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=clone.pinpointworks.com';
      this.document.cookie =
        'cookiehub' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.app.pinpointworks.com';
      this.document.cookie =
        'cookiehub' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=app.pinpointworks.com';
      this.document.cookie = 'cookiehub' + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
    }
  }

  readCookie(cookieName: string): string {
    const nameEQ = cookieName + '=';
    const cookies = this.document.cookie.split(';');

    for (let i = 0; i < cookies.length; i += 1) {
      let cookie = cookies[i];

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }

      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }

    return null;
  }

  setCookie(name: string, token: string, days?: number): string {
    let expires = '';

    if (days) {
      const date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = ` expires=${date.toUTCString()};`;
    }

    let secureFlag = ' secure;';
    const isTestEnv = !(environment.staging || environment.development || environment.production);

    // Safari ignores cookie with secure flag on localhost
    if (isTestEnv && isBrowserSafari()) {
      secureFlag = '';
    }

    this.document.cookie = `${name}=${token};${secureFlag} SameSite=None;${expires} path=/`;

    return this.document.cookie;
  }

  clearCookie(name: string): string {
    return this.setCookie(name, '', -1);
  }
}
